import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Bell } from "lucide-react";

interface BirthdayNotificationSnackbarProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
  onNotificationClick?: () => void;
}

/**
 * Auto-dismiss snackbar component for birthday notifications
 * Appears at the bottom of the screen with a button to view notifications
 */
const BirthdayNotificationSnackbar: React.FC<
  BirthdayNotificationSnackbarProps
> = ({ isOpen, message, onClose, onNotificationClick }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ type: "spring", damping: 20, stiffness: 300 }}
          className="fixed bottom-4 left-4 right-4 md:right-auto md:left-4 md:max-w-md z-50"
        >
          <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-lg shadow-2xl p-4 flex items-center justify-between gap-3">
            {/* Message with icon */}
            <div className="flex items-center gap-3 flex-1">
              <Bell className="w-5 h-5 flex-shrink-0 animate-pulse" />
              <p className="text-sm font-medium">{message}</p>
            </div>

            {/* Action buttons */}
            <div className="flex items-center gap-2 flex-shrink-0">
              {onNotificationClick && (
                <button
                  onClick={onNotificationClick}
                  className="px-3 py-1.5 bg-white text-blue-600 text-xs font-medium rounded-lg hover:bg-blue-50 transition-colors whitespace-nowrap"
                >
                  Check Now
                </button>
              )}
              <button
                onClick={onClose}
                className="p-1 hover:bg-blue-400 rounded-lg transition-colors flex-shrink-0"
                title="Dismiss"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BirthdayNotificationSnackbar;
